// extracted by mini-css-extract-plugin
module.exports = {"LoadingContainer":"Preloader_LoadingContainer__3aGlf","DisabledLoader":"Preloader_DisabledLoader__36POP"};